import { combineReducers } from 'redux';

import commons from "./commons";
import auth from "./auth";
import layout from "./layout";

export default combineReducers({
    commons,
    auth,
    layout,
});
